import SecurityUseCase from "@/usecases/SecurityUseCase";

export const emptyOrNullStringCheck = (
  val: string,
  errMsg: string = "Required field cannot be empty"
) => (val && val.length > 0) || errMsg;

export const fixedLength = (
  val: string,
  length: number,
  errMsg: string = `Should be exactly ${length} characters`
) => (val && val.length == length) || errMsg;

export const phoneValidation = (
  val: string,
  errMsg: string = "Phone number should be 10 digits"
) => fixedLength(val, 10, errMsg);

export const emailValidation = (
  val: string,
  errMsg: string = "Email should be less than 254 characters"
) => (val.length > 0 && val.length < 254) || errMsg;

export const amountCheck = (
  val: number,
  min: number,
  errMsg: string = `Amount should be greater than ${min}`
) => val > min || errMsg;

export const passwordCheck = (val: string) => {
  let errorList: string[] = [];
  if (val.length < 8) errorList.push("contain 8 characters");
  if (!/\p{Lu}/u.test(val)) errorList.push("contain an uppercase");
  if (!/\p{Ll}/u.test(val)) errorList.push("contain a lowercase");
  if (!/\d/.test(val) && /^[a-zA-Z0-9]*$/.test(val))
    errorList.push("contain a number or special character");

  if (errorList.length > 0) return `Password should ${errorList.join(", ")}`;
  else return true;
};

export const passwordMatch = (val1: string, val2: string) =>
  val1 === val2 || "Password don't match";

export const isEasilyGuessedPassword = async (val: string) => {
  const securityUseCase = new SecurityUseCase();
  const result = await securityUseCase.isEasilyGuessedPassword(val);
  if (result.status !== 200) {
    return result.title || "Error in checking password strength";
  }

  if (result.content === true) {
    return "The password is easily guessed";
  } else {
    return true;
  }
};
